import { render } from "./Surveys.vue?vue&type=template&id=62b67d18"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"

import "./Surveys.vue?vue&type=style&index=0&id=62b67d18&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__